import React from 'react';
import { JobsiteSchedulesContextType } from 'containers/jobsite/tabs/jobsiteSchedules/data/types';
import { JobsiteSchedulesContext } from './JobsiteSchedulesContext';

export function useJobsiteSchedules(): JobsiteSchedulesContextType {
  const context = React.useContext(JobsiteSchedulesContext);
  if (!context) {
    throw new Error(
      'useJobsiteSchedules must be used within a JobsiteSchedulesProvider',
    );
  }
  return context;
}
